export enum ContractType {
  CHARGING_SERVICES = 'Charging Services',
  CUSTOMER_PORTAL = 'Portal',
  SMART_METER = 'Smart Meter',
}
